import { render, staticRenderFns } from "./version-history-item.vue?vue&type=template&id=06e76ea4&scoped=true&"
import script from "./version-history-item.vue?vue&type=script&lang=js&"
export * from "./version-history-item.vue?vue&type=script&lang=js&"
import style0 from "./version-history-item.vue?vue&type=style&index=0&id=06e76ea4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e76ea4",
  null
  
)

export default component.exports